const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!motionQuery.matches) {
  document.documentElement.classList.add('s911v4-motion');

  const reveal = (element) => element.classList.add('is-visible');
  const targets = document.querySelectorAll('[data-s911v4-reveal], [data-s911v4-manifesto]');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
    );

    targets.forEach((target) => observer.observe(target));
  } else {
    targets.forEach(reveal);
  }
}
